import BPDIcon from '../assets/bpd_icon.svg?react'
import ExperimentIcon from '../assets/experiment_icon.svg?react'
import KpiIcon from '../assets/kpi_icon.svg?react'
import MethodologyIcon from '../assets/methodology_icon.svg?react'
import OnboardingIcon from '../assets/onboarding_icon.svg?react'
import SmartIcon from '../assets/smartquery_icon.svg?react'

export const questions = [
  {
    agent: 'Smart Query Agent',
    questions: [
      'How many completed experiments were run per GLA Strategic Priority in 2025?',
      'Which markets in Europe drove the increase in completed experiments between 2024 and 2025?',
      'What proportion of hypotheses were proven vs. disproven last year?',
      'Which brands are most active in experimentation, and in which OUs?',
      'Which OUs and countries are driving the majority of experimentation spend?',
      'Are higher DME investments translating into proportionally more completed experiments?',
      "Which initiatives are skewed toward 'Planned' vs. 'Completed' experiments?",
      'What percentage of hypotheses were validated vs. disproven in 2025?',
      'Which OUs/countries are generating the strongest validated learnings relative to spend?',
      'Where are we allocating budget to experiments with inconclusive results?',
    ],
    icon: SmartIcon,
  },
  {
    agent: 'Onboarding Assistant',
    questions: [
      'What are the main steps of the Experimentation @ Scale journey?',
      'Who is responsible for logging experiments in the tracker?',
      'Can you explain what the Global Learning Agenda is in simple terms?',
      "I'm new to E@S — where should I start to design my first experiment?",
      'What role does an OU Orchestrator play in the experimentation process?',
    ],
    icon: OnboardingIcon,
  },
  {
    agent: 'Methodology Assistant',
    questions: [
      'How do I decide whether to run an A/B test or a pre/post experiment?',
      'Which methodology is best for testing media effectiveness at scale?',
      'Can you explain how the ROES methodology works in E@S?',
      "What's the difference between a Learning Combo and a Best Practice Decoded in terms of methodology?",
      'When should I use NIQ versus internal tracking methods in my experiment design?',
      'Could you share more details about E@S methodologies for me?'
    ],
    icon: MethodologyIcon,
  },
  {
    agent: 'KPI Assistant',
    questions: [
      'What KPIs should I track to measure Event Impact in my experiment?',
      'Which KPIs should I focus on when conducting a Brand lift study?',
      'How do I calculate ROI for a completed E@S experiment?',
      'Which KPI is recommended for measuring incremental sales in beverage trials?',
      "What's the difference between ROES and ROI in the context of E@S?",
      'Can you suggest KPIs to track audience engagement during digital campaigns?',
      'What are the key metrics to evaluate the success of a digital media experiment',
      'Which measures should I track to understand if an innovation test delivered business impact?',
      'How do I distinguish between indicators of execution quality and indicators of business outcomes?',
      'What metrics are most relevant when aligning an experiment with the Global Learning Agenda?',
      'Can you provide examples of measurements commonly used in product testing scenarios?',
    ],
    icon: KpiIcon,
  },
  {
    agent: 'Create Experiment Assistant',
    questions: [
      'I want to log a new experiment about packaging design, what fields do I need to fill in?',
      'How do I upload a media plan to the Experiment Tracker?',
      'How do I start filling out the form to register a new experiment?',
      'What information is mandatory before submitting a new experiment for review?',
      'How do I tag an experiment under a specific GLA Strategic Priority in the tracker?',
    ],
    icon: ExperimentIcon,
  },
  {
    agent: 'BPD Assistant',
    questions: [
      'Can you show me the Best Practices Decoded from 2023 related to Media Transformation?',
      'What are the main strategic learnings captured as BPDs so far?',
      'How do we transform a validated learning into a Best Practice Decoded?',
      'Which BPDs are most relevant for campaigns in Latin America?',
      "What's the difference between tactical learnings and strategic BPDs?",
      'Which learnings from past experiments were considered strong enough to be scaled globally?',
      'Can you show me examples of insights that became standard practice across OUs?',
      'How do we identify when a learning should move from a local experiment to a global guideline?',
      'What are some of the most impactful strategic learnings generated in recent years?',
      'Which validated insights are currently being shared as references for future experiments?',
    ],
    icon: BPDIcon,
  },
]
